export enum AlertSeverityEnum {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}

export enum ErrorStatusEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

